
import Vue from  'vue'
import eventHub from '../../mixins/eventHub'
import {getBounds} from '../../utils/dom/pos.js'

export default {

    props: {
        focus: { type: Boolean, default: true }
    },

    data()
    {
        return {
            fakeScroll: !this.$root.$children[0].support.touch,
            scrollY: 0,

            playerWidth: this.$root.$children[0].windowSize[0],
            playerHeight: Math.round(this.$root.$children[0].windowSize[0] * 9 / 16),
            onPlayerReady: this._onPlayerReady,
            has3d: !this.$root.$children[0].support.touch,

            introState: 0
        }
    },

    created()
    {
        // EVENTS
        this._onResized = this._onResized.bind(this)
        this._scrollY = this._scrollY.bind(this)
        // this._enterFrame = this._enterFrame.bind(this)

        this.eventHub.$on('window:resized', this._onResized)
        // this.eventHub.$on('window:scroll:smooth', this._onScroll)
        // this.eventHub.$on('enterFrame', this._enterFrame)

        if (this.fakeScroll)
        {
            // this.eventHub.$on('window:scroll:smooth', this._onScroll)
            this.$root.$children[0].scroll.addOnSmoothScroll(this._scrollY)
        }
        else
        {
            // this.eventHub.$on('window:scroll', this._onScroll)
            this.$root.$children[0].scroll.addOnScroll(this._scrollY)
        }
    },

    mounted()
    {
        // ADD PROPERTIES
        this._contentElmt = this.$el.querySelector('.js-content')
        // this._initPhase()
        this._initBottom()


        // INIT DATAS
        this._onResized()
        this._scrollY(0)
        this._onLoaded()

        // temp for test
        /*setTimeout(() => {
            console.log('pageHeight2:', this._contentElmt.offsetHeight)
        }, 100)*/




        // this._videoTest = this.$el.querySelector('.c-video-intro')
    },

    destroyed()
    {
        this.eventHub.$off('window:resized', this._onResized)
        // this.eventHub.$off('window:scroll:smooth', this._onScroll)
        // this.eventHub.$off('enterFrame', this._enterFrame)

        if (this.fakeScroll)
        {
            // this.eventHub.$off('window:scroll:smooth', this._onScroll)
            this.$root.$children[0].scroll.addOnSmoothScroll(this._scrollY)
        }
        else
        {
            // this.eventHub.$off('window:scroll', this._onScroll)
            this.$root.$children[0].scroll.addOnScroll(this._scrollY)
        }
    },

    methods: {

        _onResized()
        {
            // SET DOM ELMTS DATAS
            // this.playerWidth = this.$root.$children[0].windowSize[0]
            // this.playerHeight = Math.round(this.$root.$children[0].windowSize[0] * 9 / 16)

            // GET DOM DATAS
            // this._updatePhase()
            this._updateBottom()
            // console.log('pageHeight1:', pageHeight)


            // CHANGE DOM DATAS
            this.$root.$children[0].setHeight( this.fakeScroll ? this._contentElmt.offsetHeight : -1 )
        },

        _scrollY( posY )
        {
            this.scrollY = posY

            if (this.focus)
            {
                if (this.fakeScroll)
                {
                    this._contentElmt.style.transform = `translateY(-${posY}px) translateZ(0)`
                }

                this._moveBottom(posY)

                /*if (this.introState < 1)
                {
                    this._playIntro()
                }*/
            }


            /*if (this._videoTest)
            {
                const root = this.$root.$children[0]
                this._videoTest.currentTime = this._videoTest.duration * posY / (root.height - root.windowSize[1])
            }*/
        },

        /*_playIntro()
        {
            if (this._videoTest)
            {
                this.introState = 1
                this._videoTest.addEventListener('ended', event =>
                {
                    this.introState = 2
                })
                this._videoTest.play()
            }
        },*/

        _onLoaded()
        {
            this.eventHub.$emit('page:loaded', this)
        },



        /*
                ┌─────────────────────────────────────────────
                │
                │       BOTTOM
                │
                └─────────────────────────────────────────────
        */

        _initBottom()
        {
            this._bottomData = {
                textElmt: this.$el.querySelector('.js-nav-bottom'),
                imgElmt: this.$el.querySelector('.js-img-bottom'),
                isOut: true,
                //bounds: { x:0, y:0, w:0, h:0 }
            }
        },

        _updateBottom()
        {
            //this._bottomData.bounds = getBounds(this._bottomData.textElmt)
        },

        _moveBottom( scrollY )
        {
            const root = this.$root.$children[0]
            const scrollMax = root.height - root.windowSize[1]
            const dist = scrollMax - scrollY
            const textDist = dist * 0.5
            const imgDist = dist * 0.2

            // console.log( isOut )

            this._bottomData.textElmt.style.transform = `translateY(${textDist}px) translateZ(0)`
            this._bottomData.imgElmt.style.transform = `translateY(${imgDist}px) translateZ(0)`
        },


        /*
                ┌─────────────────────────────────────────────
                │
                │       PHASE
                │
                └─────────────────────────────────────────────
        */

        /*_initPhase()
        {
            const bounds = {x:0, y:0, w:0, h:0}

            this._phaseTitle = {
                // bounds,
                elmt: this.$el.querySelector('.js-phase-title'),
                isOut: true,
                state: -1,
                children : this.$el.querySelectorAll('.js-phase-title__child')
            }

            this._phaseContainer = {
                bounds,
                elmt : this.$el.querySelector('.js-phase-container')
            }

            this._phaseParagraph = {
                bounds,
                elmt : this.$el.querySelector('.js-phase-paragraph-1'),
                relY : 0
            }
        },

        _updatePhase()
        {
            this._phaseContainer.bounds = getBounds(this._phaseContainer.elmt)
            this._phaseParagraph.bounds = getBounds(this._phaseParagraph.elmt)
            this._phaseParagraph.relY = this._phaseParagraph.bounds.y - this._phaseContainer.bounds.y + this._phaseParagraph.bounds.h * 0.5
        },

        _movePhase( scrollY )
        {
            const median = scrollY + this.$root.$children[0].windowSize[1] * 0.5 - (this._phaseParagraph.bounds.y + this._phaseParagraph.bounds.h * 0.5)

            const hMax = this._phaseContainer.bounds.h


            if (Math.abs(median) < 1.5 * hMax)
            {
                const pt = this._phaseTitle
                const offsetY = median * 0.5 + this._phaseParagraph.relY
                pt.elmt.style.transform = `translateY(calc(${offsetY}px - 50%)) translateZ(0)`

                // const stateF = median / (0.5 * hMax)
                const state = 0// (stateF < -0.5) ? 0 : (stateF < 0.5) ? 1 : 2

                const oldState = pt.state
                if (state !== oldState)
                {
                    for (let i = 0, l = pt.children.length; i < l; i++)
                    {
                        const child = pt.children[i]
                        if (i === oldState)
                        {
                            child.classList.remove('is-visible')
                        }
                        else if (i === state)
                        {
                            child.classList.add('is-visible')
                        }
                    }
                    pt.state = state
                }
            }

            this._phaseSetOut( Math.abs(median) > hMax )
        },

        _phaseSetOut( isOut )
        {
            if (isOut && !this._phaseTitle.isOut)
            {
                this._phaseTitle.isOut = true
                this._phaseTitle.elmt.classList.add('is-out')
            }
            else if (!isOut && this._phaseTitle.isOut)
            {
                this._phaseTitle.isOut = false
                this._phaseTitle.elmt.classList.remove('is-out')
            }
        }*/

    }
}
